"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getImageOfFaceRead = exports.renderImageOfFaceRead = void 0;
const draw_rotated_and_scaled_image_1 = require("./drawing/draw-rotated-and-scaled-image");
/**
 * Render a single face from among the 25 faces read in an image of a DiceKey.
 * Used so that we can read images with bit errors and have the user error-check
 * them for us.
 *
 * @param dstCtx The rendering context of the canvas to write into
 * @param srcImage The source image from which a DiceKey was read
 * @param faceRead The face to grab an image of.
 *
 * @returns True if successful, false if unable to find the die center/angle to read
 */
const renderImageOfFaceRead = (dstCtx, srcImage, faceRead) => {
    (0, draw_rotated_and_scaled_image_1.drawRotatedAndScaledImage)(dstCtx, srcImage, { x: dstCtx.canvas.width / 2, y: dstCtx.canvas.height / 2 }, faceRead.center, faceRead.inferredAngleInRadians, dstCtx.canvas.width / faceRead.inferredFaceSize);
    return true;
};
exports.renderImageOfFaceRead = renderImageOfFaceRead;
var srcImageRenderingCanvas;
var srcImageRenderingCtx;
var dieRenderingCanvas;
var dieRenderingCtx;
/**
 * Get an ImageData object containing a single face among the 25 faces read in
 * an image of a DiceKey. Used so that we can read images with bit errors and
 * have the user error-check them for us.
 *
 * @param dstCtx The rendering context of the canvas to write into
 * @param srcImage The source image from which a DiceKey was read
 * @param faceRead The face to grab an image of.
 *
 * @returns True if successful, false if unable to find the die center/angle to read
 */
const getImageOfFaceRead = (srcImage, faceRead, renderSize = 200) => {
    var _a;
    if (dieRenderingCanvas == null || dieRenderingCtx == null) {
        dieRenderingCanvas = document.createElement("canvas");
        dieRenderingCtx = dieRenderingCanvas.getContext("2d");
    }
    if (dieRenderingCanvas.width !== renderSize || dieRenderingCanvas.height !== renderSize) {
        const dieRenderingSize = (_a = renderSize === null || renderSize === void 0 ? void 0 : renderSize.toString()) !== null && _a !== void 0 ? _a : "200";
        dieRenderingCanvas.setAttribute("width", dieRenderingSize);
        dieRenderingCanvas.setAttribute("height", dieRenderingSize);
    }
    if (srcImage instanceof ImageData) {
        if (srcImageRenderingCanvas == null || srcImageRenderingCtx == null) {
            srcImageRenderingCanvas = document.createElement("canvas");
            srcImageRenderingCtx = srcImageRenderingCanvas.getContext("2d");
        }
        if (srcImageRenderingCanvas.width !== srcImage.width || srcImageRenderingCanvas.height !== srcImage.height) {
            srcImageRenderingCanvas.setAttribute("width", srcImage.width.toString());
            srcImageRenderingCanvas.setAttribute("height", srcImage.height.toString());
        }
        srcImageRenderingCtx.putImageData(srcImage, 0, 0);
        (0, exports.renderImageOfFaceRead)(dieRenderingCtx, srcImageRenderingCanvas, faceRead);
    }
    else {
        (0, exports.renderImageOfFaceRead)(dieRenderingCtx, srcImage, faceRead);
    }
    const { width, height } = dieRenderingCanvas;
    return dieRenderingCtx.getImageData(0, 0, width, height);
};
exports.getImageOfFaceRead = getImageOfFaceRead;
//# sourceMappingURL=get-image-of-face-read.js.map